import { LOGGED_OUT_PATH } from '../../constants'
import { FRESH_LOGIN_PARAM } from '../sso'
import type { SSO_CLIENT } from '../sso'

/**
 * Where Cognito's /logout returns to after a SIGN-OUT.
 *
 * Its own variable because the endpoint is shared but the destination is not:
 * SSOLandingPage hops through the same /logout mid-SIGN-IN and has to come back
 * to a route that resumes authorizing, not to the logged-out page.
 *
 * Set to <origin>/logged-out in an environment once every app client there lists
 * that URL in its allowed sign-out URLs, and the pass through /login disappears.
 * Where it is unset it falls back to the older variable, so each environment is
 * switched -- or switched back -- on its own. Keep /login registered alongside
 * it: the SIGN-IN hop and a switch back both still return there.
 */
export const cognitoSignOutRedirectUri = (): string | undefined =>
  process.env.REACT_APP_COGNITO_SIGNOUT_REDIRECT_URI ??
  process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI

/** Carries the SSO client an ended session belonged to, e.g. ?source=TELECARE_AUTH0. */
export const LOGGED_OUT_SOURCE_PARAM = 'source'

export const buildLoggedOutUrl = (
  clientName: SSO_CLIENT | undefined,
  cognitoSessionCleared: boolean
): string => {
  if (!clientName) return LOGGED_OUT_PATH
  const params = new URLSearchParams({ [LOGGED_OUT_SOURCE_PARAM]: clientName })
  if (cognitoSessionCleared) params.set(FRESH_LOGIN_PARAM, '1')
  return `${LOGGED_OUT_PATH}?${params.toString()}`
}
